export default "__VITE_ASSET__24bafa32__"